import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SourceTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/contact") {
      sessionStorage.setItem("fastAluSource", location.pathname);
    }
  }, [location.pathname]);

  return null;
};

export default SourceTracker;
